export const TAPPAY_CURRENCY = 'TWD';
export const TAPPAY_APP_ID = '14249';
/** @todo 需要移除，從其他位置傳入 */
export const TAPPAY_APP_KEY = 'app_7DwfBnIG9cNbJrpLfffmRAGAQsL1pwDTmOQ85ZkTi0BS7antuz1vGtQfaH6H';
export const TAPPAY_SERVER_TYPE = process.env.NODE_ENV === 'production' ? 'production' : 'sandbox';
export const TAPPAY_SDK_URL = 'https://js.tappaysdk.com/tpdirect/v5.1.0';
export const TAPPAY_SDK_CODE_SUCCESS = '0';
export const TAPPAY_API_CODE_SUCCESS = '0';
export const TAPPAY_API_CODE_3DSECURE_ABORT = '925';
